import React, { useEffect, useMemo } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'

import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'
import AddIcon from '@mui/icons-material/Add'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import { useAppSelector, useAppDispatch } from '../../../app/hooks'

import {
  DexSettingsButton, SmartConnectorWrapper,
} from '../../buttons'
import PageWrapper from './PageWrapper'
import { DexInput } from '../../inputs'
import { useFetchDexCurrencies } from '../../../hooks'
import { resetDexAmounts, setDexCurrency, TokenIndexer } from '../../../features/dex/dexSlice'

interface PageDexProps {
  children: React.ReactNode[]
  separator: 'downArrow' | 'plus'
}

const PageDex = ({ children, separator }: PageDexProps): JSX.Element => {
  const { token0, token1 } = useParams()
  const dispatch = useAppDispatch()
  const wallet = useAppSelector((state) => state.wallet)

  const navigate = useNavigate()
  const location = useLocation()

  const path = location.pathname
  const [, baseRoute] = path.split('/')

  const { getCurrency } = useFetchDexCurrencies()

  const currency0 = getCurrency(wallet.chainId, token0 || '')
  const currency1 = getCurrency(wallet.chainId, token1 || '')

  useEffect(() => {
    dispatch(resetDexAmounts())
    dispatch(setDexCurrency({
      indexer: TokenIndexer.TOKEN0,
      currency: currency0,
    }))
    dispatch(setDexCurrency({
      indexer: TokenIndexer.TOKEN1,
      currency: currency1,
    }))
  }, [dispatch, currency0, currency1])

  const sd = () => (
    navigate(`/${baseRoute}/${token1}/${token0}`)
  )

  const swapDirection = (token0 && token1) ? sd : undefined

  const separatorComponent = useMemo(() => {
    switch (separator) {
      case 'downArrow': {
        if (swapDirection) {
          return (
            <IconButton onClick={swapDirection}>
              <ArrowDownwardIcon />
            </IconButton>
          )
        }
        return <ArrowDownwardIcon />
      }
      case 'plus':
        return <AddIcon />
      default:
        return null
    }
  }, [separator, swapDirection])

  return (
    <PageWrapper>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 4,
        }}
      >
        {children[0]}
        <DexSettingsButton />
      </Box>
      <DexInput indexer={TokenIndexer.TOKEN0} />
      <Box p={1}>
        {separatorComponent}
      </Box>
      <DexInput indexer={TokenIndexer.TOKEN1} />
      <Box sx={{ marginTop: 4 }}>
        <SmartConnectorWrapper
          checkDex
          variant="outlined"
          color="secondary"
          size="large"
        >
          {children[1]}
        </SmartConnectorWrapper>
      </Box>
    </PageWrapper>
  )
}

export default PageDex
